export default __webpack_public_path__ + "static/media/Docks.01835e16.jpg";